import { isBrowser } from '../../window/detection';

/**
 * Microsoft Pixel (Bing UET) Tracking
 *
 * Initializes Microsoft Universal Event Tracking (UET) for Bing Ads conversion tracking.
 * This script loads the Bing tracking pixel and sends a pageLoad event.
 *
 * Based on Gatsby implementation: packages/core/src/helpers/analytics/initializeMicrosoftPixelTracking.ts
 */

/**
 * Initializes Microsoft Pixel (Bing UET) tracking.
 *
 * This function:
 * 1. Creates the UET queue (window.uetq)
 * 2. Loads the Bing tracking script (bat.bing.com/bat.js)
 * 3. Initializes UET with tracking ID 4069887
 * 4. Sends a pageLoad event
 *
 * **Important:** This should only be called once per session to avoid duplicate tracking.
 * Use a session flag or component state to prevent multiple initializations.
 *
 * @example
 * // Only initialize for Bing campaign variants
 * if (isBingVariant && !isInitialized) {
 *   initializeMicrosoftPixelTracking();
 *   setIsInitialized(true);
 * }
 */
export function initializeMicrosoftPixelTracking(): void {
  if (!isBrowser()) {
    return; // Server-side - skip
  }

  /* eslint-disable */
  const w = window as any;
  const d = document;
  const t = 'script';
  const r = '//bat.bing.com/bat.js';
  const u = 'uetq';
  let f: () => void;
  let n: any; // Cast to any to support legacy onreadystatechange
  let i: HTMLScriptElement | null;

  // Initialize UET queue
  w[u] = w[u] || [];

  // UET initialization function
  f = function () {
    const o = { ti: '4069887' } as any;
    o.q = w[u];
    w[u] = new w.UET(o);
    w[u].push('pageLoad');
  };

  // Create and load script
  n = d.createElement(t);
  n.src = r;
  n.async = true;
  // onreadystatechange is legacy IE API, not in modern TypeScript types
  n.onload = n.onreadystatechange = function () {
    const s = (this as any).readyState;

    if (s && s !== 'loaded' && s !== 'complete') {
      return;
    }

    f();
    n.onload = n.onreadystatechange = null;
  };

  i = d.getElementsByTagName(t)[0] as HTMLScriptElement;
  i.parentNode?.insertBefore(n, i);
  /* eslint-enable */
}
